import type { Option } from '@comparit/core';
import { Fertighaus } from '../../../interfaces';

export const fertighausOptions: Option<Fertighaus>[] = [
  { label: 'Ja', value: Fertighaus.Ja },
  { label: 'Nein', value: Fertighaus.Nein },
];
